import { NodeColorMap, NodeIconMap } from './constants';
import type { GraphNodeType } from './types';

export const getNodeColor = (type: GraphNodeType) =>
  NodeColorMap[type] || NodeColorMap.LOGIC;

export const getNodeIcon = (type: GraphNodeType) =>
  NodeIconMap[type] || NodeIconMap.LOGIC;

export const getNodeId = (id: string) => `graph-node-${id}`;
